import MonthYearRangeSelect from "../src/rails/month_year_range_select"

jQuery(document).ready(function () {
  if (jQuery('#analytics-content-restructure').length === 0) return 
  bindAnalyticsCalendarSelectToComponent()
})

const bindAnalyticsCalendarSelectToComponent = function() {
  try {
    new MonthYearRangeSelect({parentId: 'analytics_date_select'})
  } catch (e) {
    console.error("Error binding MonthYearRangeSelect to component:", e)
  }
}

window.bindAnalyticsCalendarSelectToComponent = bindAnalyticsCalendarSelectToComponent
